import {useLocation, useNavigate} from 'react-router';
import {SVG} from '../../../constants/assetLists';
import QUERY_KEYS from '../../../constants/queryKeys';
import {useQueryClient} from '@tanstack/react-query';

function HeaderLogo() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();

  const handleLogoClick = () => {
    if (location.pathname === '/operations') {
      // Refresh announcements if already on Operations tab
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEYS.GET_ALL_ANNOUNCEMENTS],
      });
    } else {
      navigate('/operations');
    }
  };

  return (
    <div className="w-[180px]">
      <button className="w-[140px] h-[62px]" onClick={handleLogoClick}>
        <img
          src={SVG.logoIcon}
          alt="logo"
          className="w-full h-full object-contain"
        />
      </button>
    </div>
  );
}

export default HeaderLogo;
